<template>
  <div>
    <div v-if="showHeader" class="login-inner-header">
      <div class="login-inner-header-back" @click="goBack">
        <van-icon name="arrow-left" size="20" />
      </div>
    </div>
    <keep-alive>
      <component
        :is="currentComponent"
        ref="child"
        :default-email="defaultEmail"
        :action-type="actionType"
        @go-page="goPage"
        @back="goBack"
      />
    </keep-alive>
  </div>
</template>

<script lang="ts"></script>

<script lang="ts" setup>
import { ref, computed, watch, onMounted } from 'vue'
import SignIn from '@/components/sign-in/Main.vue'
import ForgotPassword from '@/components/sign-in/ForgotPassword.vue'
import { PageType, Action, ActionType } from './constant'

const props = withDefaults(
  defineProps<{
    /**
     * 页面类型
     */
    pageType?: PageType
    /**
     * 操作类型
     */
    actionType?: ActionType
    defaultEmail?: string
    /**
     * 是否显示头部
     */
    showHeader?: boolean
  }>(),
  {
    pageType: PageType.SignIn,
    actionType: ActionType.Login,
    defaultEmail: '',
    showHeader: false
  }
)

const componentMap = {
  [PageType.SignIn]: SignIn,
  [PageType.ForgotPassword]: ForgotPassword,
}

const emits = defineEmits<{
  'update:pageType': [PageType]
  'update:action': [Action]
}>()
const innerPageType = ref(props.pageType)

const currentComponent = computed(() => componentMap[innerPageType.value])

watch(innerPageType, () => {
  emits('update:pageType', innerPageType.value)
})
watch(
  () => {
    return props.pageType
  },
  () => {
    innerPageType.value = props.pageType
  }
)
const child = ref()
const goPage = (nextPageType: PageType) => {
  // 如果是忘记密码，把邮箱也带过去
  if (nextPageType === PageType.ForgotPassword) {
    const email = child.value.getEmail()
    setTimeout(() => {
      child.value.updateEmail(email)
    }, 50)
  }
  // 如果是手机号登录注册，把手机号也带过去
  if (nextPageType === PageType.PhoneVerification) {
    const phoneInfo = child.value.getPhoneInfo()
    setTimeout(() => {
      child.value.updatePhoneInfo(phoneInfo)
    })
  }

  // 根据不同页面状态，进行跳转
  innerPageType.value = nextPageType
}

const goBack = () => {
  if (innerPageType.value === PageType.ForgotPassword) {
    innerPageType.value = PageType.SignIn
  } else if (innerPageType.value === PageType.SignIn) {
    emits('update:action', Action.Back)
  }
}
</script>

<style scoped lang="scss">
.login-inner-header {
  padding: 4px 10px 0;
}
.login-inner-header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
</style>
